export default __webpack_public_path__ + "static/img/img_2.517b35c.png";